class BlogFilter extends HTMLElement {
  connectedCallback() {
    if (this.__blogFilterInit) return;
    this.__blogFilterInit = true;

    this.searchInput = this.querySelector('.blog-filter__search');
    this.tagButtons = Array.from(this.querySelectorAll('.blog-filter__tag'));
    this.articles = Array.from(this.querySelectorAll('[data-blog-article]'));
    this.noResults = this.querySelector('[data-blog-no-results]');

    if (!this.tagButtons.length || !this.articles.length) return;

    const { tag, q } = this._readUrl();
    if (this.searchInput) this.searchInput.value = q;
    this._setActiveTag(tag);
    this._filter();

    this.tagButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this._setActiveTag((btn.dataset.blogTag || '__all').toLowerCase());
        this._filter();
      });
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this._filter());
    }
  }

  _readUrl() {
    const url = new URL(window.location.href);
    const tag = (url.searchParams.get('tag') || '__all').toLowerCase();
    const q = (url.searchParams.get('q') || '').toLowerCase();
    return { tag, q };
  }

  _writeUrl({ tag, q }) {
    const url = new URL(window.location.href);
    if (tag && tag !== '__all') url.searchParams.set('tag', tag);
    else url.searchParams.delete('tag');
    if (q) url.searchParams.set('q', q);
    else url.searchParams.delete('q');
    window.history.replaceState({}, '', url.toString());
  }

  _setActiveTag(tagHandle) {
    const target = (tagHandle || '__all').toLowerCase();
    this.tagButtons.forEach((btn) => {
      const isActive = (btn.dataset.blogTag || '').toLowerCase() === target;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  _filter() {
    const activeBtn = this.tagButtons.find((b) => b.classList.contains('active')) || this.tagButtons[0];
    const activeTag = ((activeBtn?.dataset.blogTag || '__all') + '').toLowerCase();
    const query = ((this.searchInput?.value || '') + '').toLowerCase().trim();

    let visibleCount = 0;
    for (const el of this.articles) {
      const tags = ((el.dataset.articleTags || '') + '').toLowerCase();
      const text = `${((el.dataset.articleTitle || '') + '').toLowerCase()} ${((el.dataset.articleExcerpt || '') + '').toLowerCase()}`;

      const matchesTag = activeTag === '__all' || tags.split(',').includes(activeTag);
      const matchesQuery = !query || text.includes(query);
      const show = matchesTag && matchesQuery;

      el.classList.toggle('hidden', !show);
      if (show) visibleCount += 1;
    }

    if (this.noResults) this.noResults.classList.toggle('hidden', visibleCount !== 0);
    this._writeUrl({ tag: activeTag, q: query });
  }
}

if (!customElements.get('blog-filter')) {
  customElements.define('blog-filter', BlogFilter);
}
